import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { LandingContext } from './LandingContext';
import config from '../../Common/Configurations/APIConfig';
import apiService from '../../Common/Configurations/APIService';
import PublicHeader from '../../Common/Layout/PublicHeader';
import B2CFooter from './B2CFooter';
import B2CTopHeader from './B2CTopHeader';
import DefaultData from '../../CompanyData/DefaultData';

const B2CLayout = () => {
    const [landingData, setLandingData] = useState({});
    useEffect(() => {
        const getLandingData = async () => {
            const companyId = DefaultData.DEFAULTCOMPANYID;
            if (!companyId) return;
            try {
                const res = await apiService.getById(`${config.GETLANDINGBYCOMPANY}`,`${companyId}`);
                if (res !== null) {
                    setLandingData(res);
                }
            } catch (error) {
                console.error("Failed to fetch landing page data", error);
            }
        };
        getLandingData();
    }, []); // Runs once

    return (
        <LandingContext.Provider value={landingData}>
            <div className="b2c-wrapper">
                <B2CTopHeader value={landingData}></B2CTopHeader>
                <PublicHeader value={landingData} />
                <main className="main-content">
                    {/* The Outlet renders the current page (e.g., HolidayScreen, FlightSearch) */}
                    <Outlet />
                </main>
                <B2CFooter value={landingData} />
            </div>
        </LandingContext.Provider>
    );
};

export default B2CLayout;